import calls from '@/backend/api-calls'

const state = () => ({
  skids: [],
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true,
  project: null,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null,
    piece_no: null,
    skid_no: null,
    is_sent: null
  }
})


const getters = {
  ids: state => {
    return state.skids.map(d => d.id);
  }
}


const actions = {
  getSkids: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.skids.get(parameters)
        .then(resp => {
          commit("setSkids", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addSkid({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.skids.post(data)
        .then(resp => {
          commit("insertSkid", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateSkid: ({commit}, { skidId, data }) => {
    return new Promise((resolve, reject) => {
      calls.skid.put(skidId, data).then(
        resp => {
          commit("insertUpdatedSkid", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Skid successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteSkid: ({commit}, skidId) => {
    return new Promise((resolve, reject) => {
      calls.skid.delete(skidId).then(
        resp => {
          commit("removeSkid", skidId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Skid successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  // addItem: ({commit}, item) => {
  //   return new Promise((resolve, reject) => {
  //     calls.productionSheetsItems.post(item).then(
  //       resp => {
  //         commit("insertItem", resp.data);
  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}


const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setSkids(state, data) {
    state.pagination = data.pagination;
    state.skids = data.results;
  },
  insertSkid(state, data) {
    state.skids.push(data);
  },
  insertUpdatedSkid(state, data) {
    state.skids.forEach((skid, i) => {
      if (skid.id == data.id) {
        state.skids.splice(i, 1, data);
      }
    })
  },
  removeSkid(state, skidId) {
    state.skids.forEach((skid, i) => {
      if (skid.id == skidId) {
        state.skids.splice(i, 1);
      }
      const index = state.selected.indexOf(skidId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  setProject(state, value) {
    state.project = value;
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}